import React, { Component, ComponentType } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect, ConnectedProps } from 'react-redux';
import { compose } from 'redux';
import { DataManager, Query } from '@syncfusion/ej2-data';
import { RootState } from '../../store';
import { IWebinarDetailsContainerStateProps, IWebinarDetailsContainerDispatchProps } from '../../interfaces/props/IWebinarDetailsProps';
import * as webinarDetailsStore from '../../store/modules/webinarDetails.store';
import { URL } from '../../common/constants';
import { IMyRule } from '../../common/model/myRule.model';
import { RuleCondition } from '../../common/model/enumerations/ruleCondition.model';
import { RuleOperator } from '../../common/model/enumerations/ruleOperator.model';
import { dataManagerService, oDataService, queryBuilderService } from '../../services';
import Webinar from './webinar/webinar';
import { IWebinar } from '../../common/model/webinar.model';

type WebinarsListContainerPropsType = PropsFromRedux & RouteComponentProps & WithTranslation;

class WebinarDetailsContainer extends Component<WebinarsListContainerPropsType> {
  public webinarsDataManager: DataManager = null;
  public webinarsQuery: Query = new Query()
    .select(['id', 'name', 'speakers', 'date', 'description', 'videoUrl', 'active']);

  public constructor(props: WebinarsListContainerPropsType) {
    super(props);

    this.webinarsDataManager = dataManagerService.buildDataManager(URL.ODATA.WEBINAR_FILTERS);
  }

  public componentDidMount() {
    this.fetchWebinars();
  }

  public render() {
    const {
      webinars,
      i18n,
      userId,
      companyId
    } = this.props;


    const items = webinars.map((item, index) => (
      <Webinar key={item.id} webinar={item as IWebinar} isEven={(index % 2 == 0)} userId={userId} companyId={companyId} />
    ));

    return (
      <div>
        <div className='row'>
          <div className='col'>
            <h2>{i18n.t('webinarsList.title')}</h2>
          </div>
        </div>
        {items}
      </div>
    );
  }

  private fetchWebinars() {
    const { fetchWebinars } = this.props;

    fetchWebinars(oDataService, this.webinarsDataManager, this.buildQuery());
  }

  private buildQuery(): Query {
    const myRule: IMyRule = {
      condition: RuleCondition.AND,
      myRules: []
    };

    myRule.myRules.push({
      field: 'active',
      operator: RuleOperator.EQUAL,
      value: true
    });

    return queryBuilderService.buildQuery(this.webinarsDataManager, myRule, this.webinarsQuery.clone());
  }
}

const mapStateToProps = (state: RootState): IWebinarDetailsContainerStateProps => ({
  webinars: state.webinarDetailsStore.webinars,
  userId: state.currentUserStore.user.id,
  companyId: state.currentUserStore.company !== undefined && state.currentUserStore.company !== null ? state.currentUserStore.company.id : null
});

const mapDispatchToProps: IWebinarDetailsContainerDispatchProps = {
  fetchWebinars: webinarDetailsStore.fetchWebinars
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default compose(
  withRouter,
  withTranslation(),
  connector
)(WebinarDetailsContainer) as ComponentType;
